(function() { window.GUID_7d865874_320f_46cd_a089_1cbd028478f4 = { getGuid: function() { return "7d865874-320f-46cd-a089-1cbd028478f4"; } }; })();
jQuery.fn.extend({
    controlIsLoaded: function (callback) {
        var me = this;
        var $me = $(me);
        var control = $me.control();
        if (control != null) {
            callback.call(this, control);
        }
        else {
            CompuSport.on("allscriptsloaded", function () {
                control = $me.control();
                if (control != null) {
                    callback.call(me, control);
                }
            });
        }
    },
    control: function () {
        var me = this;
        var $me = $(me);
        if ($me.length > 0) {
            var context = $me.data("context");
            if (context != null) {
                return context;
            }
        }
        return null;
    },
    allData: function () {
        var intID = jQuery.data(this.get(0));
        return jQuery.cache[intID];
    },
    clearAndFocus: function () {
        return this.each(function () {
            var $this = $(this);
            $this.focus();
            $this.select();
            var oldVal = $this.val();
            $this.val("");
            if (oldVal != "") {
                CS.trigger("CSClear", $this);
            }
            /*Ne sert pas necessairement mais enleve la classe au cas*/
            $this.removeClass("watermark");
        });
    },
    redraw: function () {
        $(this).each(function () {
            var $this = $(this);
            var lastOpacity = parseInt($this.css("opacity"), 10);
            var offsetOpacity = lastOpacity - 0.001;
            $this.css("opacity", offsetOpacity);
            setTimeout(function () {
                $this.css("opacity", lastOpacity);
            }, 200);
            /*Je m'abonne au click pour ainsi, recaller le refresh au cas ou le call du haut n'aurait pas fait la job*/
            $this.on("click.redraw", function () {
                $this.off("click.redraw");
                $this.css("opacity", offsetOpacity);
                setTimeout(function () {
                    $this.css("opacity", lastOpacity);
                }, 200);
            });
        });
    },
    ForceNumericOnly: function () {
        return this.each(function () {
            $(this)
                .keydown(function (e) {
                var key = e.charCode || e.keyCode || 0;
                if (key == 27) {
                    return;
                }
                var val = $(this)[0].value;
                //Check si le signe "-" est inscrit
                if (key == 109 || key == 189) {
                    if (val.indexOf("-") > -1) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                //Check si la virgule ou le point est inscrit
                if (key == 110 || key == 188 || key == 190) {
                    if (val.indexOf(",") == -1 && val.indexOf(".") == -1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                if (e.shiftKey || e.altKey || e.ctrlKey) {
                    return false;
                }
                return (key == 13 ||
                    key == 8 ||
                    key == 9 ||
                    key == 46 ||
                    (key >= 37 && key <= 40) ||
                    (key >= 48 && key <= 57) ||
                    (key >= 96 && key <= 105));
            })
                .keyup(function (e) {
                var val = $(this)[0].value;
                if (val.indexOf("-") > 0) {
                    $(this).val(val.replace("-", ""));
                }
            })
                .on("mousewheel", function (e) {
                e.preventDefault();
            });
        });
    },
    hasScrollBar: function () {
        return this.get(0) ? this.get(0).scrollHeight > this.innerHeight() : false;
    },
    Blink: function (nbTimes, blinkParameter, blinkParameterOffSet) {
        if (!this.data("blink")) {
            arguments.callee["blinker" + this.prop("id")] = new CompuSport.UI.Blinker(this);
            this.data("blink", true);
        }
        arguments.callee["blinker" + this.prop("id")].BlinkElement(nbTimes, blinkParameter, blinkParameterOffSet);
    },
    CSGridView: function (doNotTrigRefresh) {
        this.each(function () {
            try {
                let gridView = new CS.GridView($(this));
                // Check if gridView.GridViewId is not null or undefined
                if (gridView.GridViewId) {
                    // Donne access au grid de n'importe quels scripts.
                    eval("document." + gridView.GridViewId + "=gridView;");
                }
                else {
                    //console.error("gridView.GridViewId is null or undefined");
                }
                // Lêve un event que le grid est prêt
                if (typeof doNotTrigRefresh === "undefined") {
                    gridView.GridViewBody.trigger("Refreshed", gridView);
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSTextBox: function () {
        this.each(function () {
            let textbox = new CS.TextBox($(this));
        });
    },
    CSAutoComplete: function (watermarkForceOn, showFocusedTooltip) {
        this.each(function () {
            try {
                let autoComplete = new CS.AutoComplete($(this), watermarkForceOn, showFocusedTooltip);
                // Check if autoComplete.HiddenValue[0].id is not null or undefined
                if (autoComplete.HiddenValue &&
                    autoComplete.HiddenValue[0] &&
                    autoComplete.HiddenValue[0].id) {
                    // Donne access au autoComplete de n'importe quels scripts.
                    eval("document." + autoComplete.HiddenValue[0].id + "=autoComplete;");
                }
                else {
                    //console.error("autoComplete.HiddenValue[0].id is null or undefined");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSWaterMark: function (forceOn, showFocusedTooltip) {
        this.each(function () {
            if (IsDefined(typeof CS.WaterMark)) {
                let watermark = new CS.WaterMark($(this), forceOn, showFocusedTooltip);
            }
        });
    },
    CSCalendarPicker: function () {
        this.each(function () {
            try {
                let datePicker = new CS.CalendarPicker($(this));
                // Check if datePicker.DatePickerId is not null or undefined
                if (datePicker.DatePickerId) {
                    // Donne access au datepicker de n'importe quels scripts.
                    eval("document." + datePicker.DatePickerId + "=datePicker;");
                }
                else {
                    //console.error("datePicker.DatePickerId is null or undefined");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSDatePicker: function () {
        this.each(function () {
            try {
                let datePicker = new CS.DatePicker($(this));
                // Check if datePicker.DatePickerId is not null or undefined
                if (datePicker.DatePickerId) {
                    // Donne access au datepicker de n'importe quels scripts.
                    eval("document." + datePicker.DatePickerId + "=datePicker;");
                }
                else {
                    //console.error("datePicker.DatePickerId is null or undefined");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSCheckBox: function () {
        this.each(function () {
            try {
                let checkbox = new CS.CheckBox($(this));
                if (checkbox.NotImplemented)
                    return;
                // Check if checkbox.CheckBoxId is not null or undefined
                if (checkbox.CheckBoxId) {
                    // Donne access au checkbox de n'importe quels scripts.
                    eval("document." + checkbox.CheckBoxId + "=checkbox;");
                }
                else {
                    //console.error("checkbox.CheckBoxId is null or undefined");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSCheckBoxV2: function (dontBindEvents) {
        if (dontBindEvents == null) {
            dontBindEvents = false;
        }
        this.each(function () {
            let checkBox = new CS.CheckBoxV2($(this), dontBindEvents);
            checkBox.CheckBox.data("context", checkBox);
        });
    },
    CSColorPicker: function () {
        this.each(function () {
            try {
                let colorPicker = new CS.ColorPicker($(this));
                // Check if colorPicker.ColorPickerId is not null or undefined
                if (colorPicker.ColorPickerId) {
                    // Donne access au colorPicker de n'importe quels scripts.
                    eval("document." + colorPicker.ColorPickerId + "=colorPicker;");
                }
                else {
                    //console.error("colorPicker.ColorPickerId is null or undefined");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSDropDown: function () {
        this.each(function () {
            try {
                let dropdown = new CS.DropDown($(this));
                // Check if dropdown.DropDownId is not null or undefined
                if (dropdown.DropDownId) {
                    // Donne access au dropDown de n'importe quels scripts.
                    eval("document." + dropdown.DropDownId + "=dropdown;");
                }
                else {
                    //console.error("dropdown.DropDownId is null or undefined");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSDropDownCheckboxes: function () {
        this.each(function () {
            try {
                let DropDownCheckboxes = new CS.DropDownCheckboxes($(this));
                // Check if DropDownCheckboxes.DropDownCheckboxesId is not null or undefined
                if (DropDownCheckboxes.DropDownCheckboxesId) {
                    // Donne access au DropDownCheckboxes de n'importe quels scripts.
                    eval("document." +
                        DropDownCheckboxes.DropDownCheckboxesId +
                        "=DropDownCheckboxes;");
                }
                else {
                    //console.error(
                    //    "DropDownCheckboxes.DropDownCheckboxesId is null or undefined"
                    //);
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSDropDownV2: function () {
        this.each(function () {
            let dropdown = new CS.DropDownV2($(this));
        });
    },
    CSRadio: function () {
        this.each(function () {
            try {
                let radio = new CS.Radio($(this));
                // Check if radio.RadioId is not null or undefined and not an empty string
                if (radio.RadioId) {
                    // Donne access au radio de n'importe quels scripts.
                    eval("document." + radio.RadioId + "=radio;");
                }
                else {
                    //console.error("radio.RadioId is null, undefined, or an empty string");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    CSScanBox: function () {
        this.each(function () {
            var scanBox = new CS.ScanBox($(this));
        });
    },
    CSTimePicker: function () {
        this.each(function () {
            try {
                var timePicker = new CS.TimePicker($(this));
                // Check if timePicker.TimePickerId is not null or undefined
                if (timePicker.TimePickerId) {
                    // Donne access au timePicker de n'importe quels scripts.
                    eval("document." + timePicker.TimePickerId + "=timePicker;");
                }
                else {
                    //console.error("timePicker.TimePickerId is null or undefined");
                }
            }
            catch (error) {
                console.error("An error occurred:", error);
            }
        });
    },
    scrollTo: function (target, duration, basedOnRelativePosition, scrollOffset) {
        if (target.length > 0) {
            if (duration == null) {
                duration = 250;
            }
            let offset = 0;
            if (scrollOffset != null) {
                offset = scrollOffset;
            }
            if (basedOnRelativePosition != null && basedOnRelativePosition) {
                this.animate({ scrollTop: $(this).scrollTop() + target.position().top + offset }, duration);
            }
            else {
                this.animate({ scrollTop: $(this).scrollTop() + target.offset().top + offset }, duration);
            }
        }
    },
    animateAppendTo: function (sel, speed) {
        var $this = this, newEle = $this.clone(true).appendTo(sel), newPos = newEle.position();
        newEle.hide();
        $this.css("position", "absolute").animate(newPos, speed, function () {
            newEle.show();
            $this.remove();
        });
        return newEle;
    },
    /**
     * Detect if the constructor was called before. If not, the method set data('instantiated') to true for next call
     */
    instantiated: function () {
        let targetToTest = $(this);
        if (targetToTest.data("instantiated") == true) {
            return true;
        }
        else {
            targetToTest.data("instantiated", true);
        }
    },
    isReady: function (callback) {
        let targetToTest = this;
        let interval = null;
        let exit = false;
        let attempt = 0;
        if (targetToTest != null && targetToTest.length != 0) {
            let targetToTestHtml = targetToTest[0];
            let lastHeight = targetToTestHtml.offsetHeight;
            interval = setInterval(function () {
                if (attempt > 100) {
                    clearInterval(interval);
                }
                attempt += 1;
                if (lastHeight != targetToTestHtml.offsetHeight) {
                    lastHeight = targetToTestHtml.offsetHeight;
                }
                else {
                    clearInterval(interval);
                    setTimeout(function () {
                        if (!exit) {
                            callback.call(this);
                        }
                        exit = true;
                    }, 0);
                }
            }, 100);
        }
        return;
    },
});
//$.ajaxAntiForgery = function (settings: JQueryAjaxSettings) {
//    /*Cette section est obligatoire, sinon, toutes les proprietes qui ont une valeur undefined ne sont tout simplement pas transigé vers le server et elles sont perdu
//     * En les settant a null, elle sont poussée.
//     */
//    for (var property in settings.data) {
//        if (settings.data.hasOwnProperty(property)) {
//            if (settings.data[property] == undefined) {
//                settings.data[property] = null;
//            }
//        }
//    }
//    let antiforgeryTokenValue = $('input[name=__RequestVerificationToken]').last().val();
//    settings.headers = { 'RequestVerificationToken': $('[name="__RequestVerificationToken"]').val() };
//    return $.ajax(settings);
//};

//# sourceMappingURL=JQueryExtension.js.map
